import React, { memo } from 'react';
import DataTableSkeleton from 'base/components/table/DataTable/DataTableSkeleton';
import Skeleton from 'base/components/Skeleton';
import LargeLabel from 'base/components/LargeLabel';
import { DataTableCheckboxWrapper }
  from 'base/components/table/CheckboxDataTable/CheckboxDataTable';


const FileExplorerTableSkeleton = () => (
  <DataTableSkeleton>
    <div className="rt-td" style={{ width: '65px', maxWidth: '65px' }}>
      <DataTableCheckboxWrapper style={{ width: '100px' }} />
    </div>
    <div className="rt-td" style={{ width: '90px', maxWidth: '90px' }}>
      <Skeleton
        width="23px"
        height="23px"
        borderRadius="100px"
        heightRandomness={0}
        widthRandomness={0}
      />
    </div>
    <div className="rt-td" style={{ maxWidth: '300px' }}>
      <LargeLabel><Skeleton width="80%" /></LargeLabel>
    </div>
  </DataTableSkeleton>
);

export default memo(FileExplorerTableSkeleton);
